import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/seguin")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Awnings Seguin TX & Outdoor Curtains Seguin | Texas Awning Company",
      description: "Awnings Seguin, outdoor curtains Seguin, sail shades, patio & pergola covers, aluminum welding. Texas awning company headquartered in Seguin since 1992.",
      keywords: "awnings Seguin, outdoor curtains Seguin, awning company Seguin, Texas awning company, custom awnings Seguin, commercial awnings Seguin, commercial awnings Texas, residential awnings Seguin, sail shades Seguin, patio covers Seguin, pergola covers Seguin, aluminum welding Seguin, custom fabrication Seguin TX, Texas Made Shade",
      image: hero,
      socialTitle: "Awnings, Outdoor Curtains, Sail Shades & Welding — Seguin, TX",
      socialDescription: "Awnings Seguin + outdoor curtains Seguin. Texas awning company building welded aluminum + Sunbrella canvas shade for Guadalupe County.",

    }),
    scripts: cityHeadScripts("Seguin", "Guadalupe County"),
  }),
  component: () => <CityHomePage city="Seguin" region="Guadalupe County" />,
});
